<template>
  <v-card class="mx-auto pa-0" height="400" width="400" :color="customColor('cardColor')" @click="$emit('click')">
    <v-row no-gutter style="height: 250px">
      <v-col align-self="center">
        <CarouselBox :items="carouselItems" :hideDelimiter="true" imgMaxHeight="200" />
      </v-col>
    </v-row>
    <v-row class="ma-0 pt-1" justify="space-between">
      <v-col cols="4" sm="5">
        <v-img height="128" width="128" :src="data.icon" contain></v-img>
      </v-col>
      <v-col cols="8" sm="7">
        <v-card-text>
          <v-row>
            <div class="text-h6 text-truncate" :style="customColor('titleColor')">{{ data.name }}</div>
          </v-row>
          <v-row>
            <div class="caption text-truncate" :style="customColor('contentColor')">{{ data.publisherName }}</div>
          </v-row>
          <v-row class="mt-10 mt-sm-14" justify="space-between">
            <v-rating
              :value="data.rating"
              :color="customColor('ratingColor')"
              :background-color="customColor('ratingColor')"
              dense
              half-increments
              readonly
              size="12"
            ></v-rating>
            <div v-if="!discount.exist" style="font-size: 12px" :style="customColor('priceColor')">
              NT${{ price(data.price) }}{{ unit(data.price) }}
            </div>
            <div v-else class="text-decoration-line-through" style="font-size: 12px" :style="customColor('priceColor')">
              NT${{ price(data.price) }}{{ unit(data.price) }}
            </div>
          </v-row>
          <v-row v-show="discount.exist" justify="space-between">
            <div style="font-size: 12px" :style="customColor('discountColor')">{{ discountPeriod }}</div>
            <div style="font-size: 12px" :style="customColor('discountColor')">NT${{ price(discount.price) }}{{ unit(discount.price) }}</div>
          </v-row>
        </v-card-text>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import CarouselBox from '@/components/CarouselBox.vue';
import Product from '../store/product';

export default {
  name: 'CardBig',
  props: {
    data: { type: Object, required: true },
    styleInfo: {
      type: Object,
      default: () => ({
        cardColor: 'white',
        titleColor: '#757673',
        contentColor: '#757673',
        ratingColor: '#757673',
        priceColor: '#007EAE',
        discountColor: 'red',
      }),
    },
  },
  components: { CarouselBox },
  data: () => ({
    discount: {},
  }),
  computed: {
    carouselItems() {
      const ary = [];
      for (let i = 0; i < 3; i += 1) {
        if (this.data[`urls${i}`]) {
          ary.push({ src: this.data[`urls${i}`] });
        }
      }
      // if (this.app.videoUrl) ary.push({ url: `${this.app.videoUrl.replace('watch?v=', 'embed/')}?rel=0&autoplay=1` });
      return ary;
    },
    discountPeriod() {
      return Product.discountPeriod();
    },
  },
  created() {
    this.discount = Product.discountProc(this.data.discountPeriod, this.data.discount);
  },
  methods: {
    customColor(type) {
      switch (type) {
        case 'cardColor':
        case 'ratingColor':
          return this.styleInfo[type];
        default:
          return `color: ${this.styleInfo[type]}`;
      }
    },
    price(price) {
      return Product.price(price);
    },
    unit(price) {
      return this.$t(Product.unit(price));
    },
  },
};
</script>
